<template>
    <div style="display: none">
        <slot v-if="ready"></slot>
    </div>
</template>

<script>
import L from "leaflet";
import { IRouter, IGeocoder, LineOptions } from "leaflet-routing-machine";
import { findRealParent } from "vue2-leaflet";
import OpenRouteService from "./leaflet-routing-openroute.js";

const props = {
    visible: {
        type: Boolean,
        default: true,
    },
    waypoints: {
        type: Array,
        required: true,
    },
    router: {
        type: IRouter,
    },
    plan: {
        type: L.Routing.Plan,
    },
    geocoder: {
        type: IGeocoder,
    },
    lineOptions: {
        type: LineOptions,
    },
    routeLine: {
        type: Function,
    },
    autoRoute: {
        type: Boolean,
        default: true,
    },
    routeWhileDragging: {
        type: Boolean,
        default: false,
    },
    routeDragInterval: {
        type: Number,
        default: 500,
    },
    waypointMode: {
        type: String,
        default: "connect",
    },
    useZoomParameter: {
        type: Boolean,
        default: false,
    },
    showAlternatives: {
        type: Boolean,
        default: false,
    },
    altLineOptions: {
        type: LineOptions,
    },
};
export default {
    props,
    name: "LHighwayRoutes",
    data() {
        return {
            parentContainer: null,
            ready: false,
            layer: null,
            customRouter: {},
            api_key: process.env.MIX_OPEN_ROUTE_SERVICE_API_KEY,
        };
    },
    mounted() {
        this.parentContainer = findRealParent(this.$parent);
        this.add();
        this.ready = true;
    },
    beforeDestroy() {
        return this.layer ? this.layer.remove() : null;
    },
    methods: {
        add() {
            if (this.parentContainer._isMounted) {
                const {
                    waypoints,
                    autoRoute,
                    routeWhileDragging,
                    routeDragInterval,
                    waypointMode,
                    useZoomParameter,
                    showAlternatives,
                } = this;
                let plan = L.Routing.plan(waypoints, {
                    createMarker: function (i, wp) {
                        return null;
                    },
                });
                let customRouter = new L.routing.openrouteservice(
                    this.api_key,
                    {
                        host: "https://directions.hac.hr/ors",
                        profile: "driving-car",
                        instructions: false,
                        routingQueryParams: {
                            preference: "recommended",
                            maneuvers: true,
                        },
                    }
                );
                const options = {
                    waypoints,
                    autoRoute,
                    routeWhileDragging,
                    routeDragInterval,
                    waypointMode,
                    useZoomParameter,
                    showAlternatives,
                    draggableWaypoints: false,
                    lineOptions: {
                        addWaypoints: false,
                        styles: [
                            {
                                color: "#015C32",
                                weight: 4,
                            },
                        ],
                    },
                    show: false,
                    plan,
                    router: customRouter,
                    fitSelectedRoutes: false,
                };
                const { mapObject } = this.parentContainer;
                const routingLayer = L.Routing.control(options);
                routingLayer.addTo(mapObject);
                this.layer = routingLayer;
            }
        },
    },
};
</script>

<style>
@import "~leaflet-routing-machine/dist/leaflet-routing-machine.css";
</style>
